import type { Role } from '../types';

export function UserTitleBadge({ role, customTitle, compact = false }: { role?: Role | string | null; customTitle?: string | null; compact?: boolean }) {
  const custom = String(customTitle || '').trim();
  const isMember = role === 'member';
  const label = custom || (isMember ? '成员' : '管理员');
  const tone = custom ? 'custom' : isMember ? 'member' : 'admin';
  return <span className={'user-title-badge ' + tone + (compact ? ' compact' : '')} title={custom ? '自定义头衔：' + custom : '默认头衔'}>{label}</span>;
}
